import type { CircularProgressProps as BaseCircularProgressProps } from '@mui/joy/CircularProgress';
import { default as BaseCircularProgress } from '@mui/joy/CircularProgress';
import { clsx } from 'clsx';
import { forwardRef, type JSX, useMemo } from 'react';
import type { LoaderProps, LoaderVariants } from './types';

const variantValueMap: Record<LoaderVariants, number> = {
  arc: 30,
  circle: 25,
};

const Loader = forwardRef<HTMLSpanElement, LoaderProps>((props, ref): JSX.Element => {
  const { className, strokeColor, size = 'sm', variant = 'circle', slotProps, ...rest } = props;

  const circularProgressSlotProps = useMemo<BaseCircularProgressProps['slotProps']>(() => {
    const dataAttrs = { 'data-size': size, 'data-variant': variant };
    return {
      root: { ...slotProps?.root, ...dataAttrs },
      track: { ...dataAttrs },
      progress: { className: strokeColor, ...dataAttrs },
    };
  }, [strokeColor, size, variant, slotProps?.root]);

  return (
    <BaseCircularProgress
      className={clsx('ua-loader-root', className)}
      determinate={false}
      ref={ref}
      value={variantValueMap[variant]}
      {...rest}
      slotProps={circularProgressSlotProps}
    />
  );
});

Loader.displayName = 'Loader';

export { BaseCircularProgress as CircularProgress };
export default Loader;
